var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2V6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2V6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H21",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57042 16.8382L9.13748 19.2434C9.12035 19.3466 9.13729 19.4526 9.18577 19.5453C9.30892 19.7807 9.59961 19.8717 9.835 19.7485L11.9997 18.6181L14.1645 19.7485L14.3809 19.7966C14.4853 19.7985 14.5872 19.7645 14.6695 19.7004C14.8133 19.5954 14.8873 19.4196 14.862 19.2434L14.429 16.8381L16.1849 15.1545C16.3105 15.0187 16.3561 14.8272 16.3051 14.6494C16.2404 14.485 16.0944 14.3665 15.9203 14.3367L13.515 13.9759L12.4327 11.7871C12.3855 11.6897 12.3068 11.611 12.2094 11.5638C11.9703 11.448 11.6826 11.548 11.5668 11.7871L10.4844 13.9759L8.07915 14.3367C7.90503 14.3664 7.75909 14.485 7.69431 14.6494C7.64335 14.8272 7.68897 15.0187 7.81456 15.1545L9.57042 16.8382ZM10.8933 14.8899C11.0444 14.8673 11.1724 14.7668 11.2301 14.6253L11.9997 13.086L12.7694 14.6253C12.8271 14.7668 12.9551 14.8673 13.1061 14.8899L14.8139 15.1304L13.5872 16.309C13.4729 16.4221 13.4193 16.5829 13.4428 16.7419L13.7315 18.4497L12.2162 17.6319L11.9997 17.5838L11.7832 17.6319L10.2679 18.4497L10.5565 16.7419C10.5801 16.5829 10.5265 16.4221 10.4122 16.309L9.1855 15.1304L10.8933 14.8899Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIcon);
export default __webpack_public_path__ + "static/media/events-icon.bad1bd9374a22e24175dfabe3be30fdc.svg";
export { ForwardRef as ReactComponent };